if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          enabled: 'mobile-sticky-bar-enabled',
          isShow: 'mobile-sticky-bar-up',
          isHide: 'mobile-sticky-bar-down',
        };

        this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle.bind(this));
      }

      compareToggleUnsubscriber = undefined;

      connectedCallback() {
        document.body.classList.add(this.classes.enabled);
        this.show();
        this.init();
      }

      disconnectedCallback() {
        if (this.scrollHandler) {
          window.removeEventListener('scroll', this.scrollHandler);
        }

        if (this.compareToggleUnsubscriber) {
          this.compareToggleUnsubscriber();
        }
      }

      init() {
        this.calculateHeight();
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle() {
        this.show();
        this.calculateHeight();
      }

      onScrollHandler() {
        this.show();
      }

      show() {
        document.body.classList.remove(this.classes.isHide);
        document.body.classList.add(this.classes.isShow);
      }

      hide() {
        this.show();
      }
    }
  );
}

// Toggle the Kaguyasu toolbar menu panel from the mobile sticky toolbar.
(() => {
  if (window.kgyMobileStickyMenuInit) return;
  window.kgyMobileStickyMenuInit = true;

  const getToolbarPanel = () => document.getElementById('KgyStickyToolbarPanel');

  const isToolbarPanelOpen = () => {
    const panel = getToolbarPanel();
    return !!panel && panel.classList.contains('is-active');
  };

  const setMenuButtonState = (isActive) => {
    document.body.classList.toggle('mobile-sticky-toolbar-open', isActive);
    document.querySelectorAll('[data-mobile-sticky-menu-button]').forEach((button) => {
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  };

  const openToolbarPanel = () => {
    const panel = getToolbarPanel();
    if (!panel) return;

    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      panel.classList.add('is-active');
      setMenuButtonState(true);
    });
  };

  const closeToolbarPanel = () => {
    const panel = getToolbarPanel();
    if (!panel) return;

    panel.classList.remove('is-active');
    panel.setAttribute('aria-hidden', 'true');
    setMenuButtonState(false);
    window.setTimeout(() => {
      if (!panel.classList.contains('is-active')) panel.hidden = true;
    }, 320);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mobile-sticky-menu-button]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (isToolbarPanelOpen()) {
      closeToolbarPanel();
    } else {
      openToolbarPanel();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isToolbarPanelOpen()) closeToolbarPanel();
  });

  document.addEventListener('shopify:section:unload', () => {
    closeToolbarPanel();
  });

  document.addEventListener('DOMContentLoaded', () => {
    const panel = getToolbarPanel();
    if (panel) {
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
    }
    setMenuButtonState(false);
  });
})();
